import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MenuCircleBtnBacklite from './MenuCircleBtnBacklite';
import MenuCircleBtnOpenClose from './MenuCircleBtnOpenClose';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

// import RadioBtns from './RadioBtns';

const ProductViewHeader = {
   borderBottom: "1px solid #c7c7c7",
   minHeight: "42px"
}


const MenuFeatures = (props) => {

   // const [backlit, setBacklite] = useState("./img/Backlite_Off.svg");
   // const [opneClose, setOpenClose] = useState("./img/open.png");
   return (
      <div className="Accordians">
         <Accordion style={{ borderRadius: "0px",borderBottom: '1px solid #CCCCCC' }} onChange={props.onChanged} expanded={props.expanded}>
            <AccordionSummary tabIndex="1" id="feature"
               expandIcon={<ExpandMoreIcon />} style={ProductViewHeader}>
               <Typography className="accordion-headers AccordiansHeader" style={{ fontWeight: "700" }}>{props.name}</Typography>
            </AccordionSummary>
            <AccordionDetails id="camType" style={{
               borderRadius: "0px",
               background: 'transparent',
               border: 'none',
               boxShadow: 'none',
               marginLeft: '20px',
               color: 'white',
               fontWeight: 'bold',
               textTransform: 'capitalize',
               marginRight: "25px",
               paddingBottom: "0px",
               display: "block"
            }}>
               <RadioGroup className="Radio" name="gender1" value={props.value1} >
                  <FormControlLabel id="camlaptop" style={{ minwidth: "200px" }} tabIndex="1" onKeyPress={props.onclickedHDRGB} onClick={props.onclickedHDRGB} value="HD RGB-IR camera" control={<Radio id="laptopRadioHDRGB" color="primary" />} label={`${window.finalLangues.IRcamera}`} />

                  <FormControlLabel id="camlaptop2in1" style={{ minwidth: "200px" }} aria-labelledby="" tabIndex="1" onKeyPress={props.onclickedHD} onClick={props.onclickedHD} value="HD Camera" control={<Radio id='twoinoneRadioHD' color="primary" />} label={`${window.finalLangues.HDcamera}`} />
               </RadioGroup>
               {/* <RadioGroup className="Radio" name="portType" value={props.value2} >
                  <FormControlLabel id="EPortType" style={{ minwidth: "200px" }} tabIndex="1" onKeyPress={props.onClickedEPort} onClick={props.onClickedEPort} value="E Port" control={<Radio id="EPortRadio" color="primary" />} label={`${window.finalLangues.EPort}`} />

                  <FormControlLabel id="PPortType" style={{ minwidth: "200px" }} aria-labelledby="" tabIndex="1" onKeyPress={props.onClickedPPort} onClick={props.onClickedPPort} value="P Port" control={<Radio id='PPortRadio' color="primary" />} label={`${window.finalLangues.PPort}`} />
               </RadioGroup> */}
            </AccordionDetails>

            


            <AccordionDetails tabIndex="1" id="backlitBtn" onKeyPress={props.onOffBackliteClicked} onClick={props.onOffBackliteClicked}>
               <MenuCircleBtnBacklite changeBacklitImg={props.tobeChanged} submenu={`${window.finalLangues.alienfx}`} />
            </AccordionDetails>

            <AccordionDetails id="kbType" style={{
               borderRadius: "0px",
               background: 'transparent',
               border: 'none',
               boxShadow: 'none',
               marginLeft: '-40px',
               color: 'white',
               fontWeight: 'bold',
               textTransform: 'capitalize',
               marginRight: "25px"
            }}>
               <RadioGroup className="Radio" name="gender1" value={props.value} >
                  <FormControlLabel id="laptop2in1" style={{ minwidth: "200px" }} aria-labelledby="" tabIndex="1" onKeyPress={props.onclickedtwo} onClick={props.onclickedtwo} value="1-zone keyboard" control={<Radio id='twoinoneRadio' color="primary" />} label={`${window.finalLangues.zone}`} />

                  <FormControlLabel id="laptop" style={{ minwidth: "200px" }} tabIndex="1" onKeyPress={props.onclicked} onClick={props.onclicked} value="Cherry/RGB per key" control={<Radio id="laptopRadio" color="primary" />} label={`${window.finalLangues.perKey}`} />
               </RadioGroup>
            </AccordionDetails>
            <AccordionDetails tabIndex="1" id="openCloseBtn" onKeyPress={props.openClosedClicked} onClick={props.openClosedClicked}>
               <MenuCircleBtnOpenClose changeOpenCloseImg={props.tobechange} className="openclose" submenu={`${window.finalLangues.openClose}`} />
            </AccordionDetails>

         </Accordion>
      </div>
   );
}

export default MenuFeatures;